























































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import left from '@/assets/left-flair.svg';
import _ from 'lodash';

@Component
export default class MelosInput extends Vue {
  @Prop() private icon?: string;
  @Prop() private value!: string;
  @Prop() private type!: string;

  private get content(): string {
    return this.value;
  }

  private set content(data: string) {
    this.$emit('input', data);
  }
}

